import {IconButton, Tooltip} from '@mui/material'
import {observer} from 'mobx-react-lite'
import {makeOcStyles} from '@oc/styles'
import {OcAppBarActionContext, ocAppBarActions} from './OcAppBarActions'
import {useOcAppBarState} from '../../Contexts/OcAppBarStateContext'
import {Ecosystem} from '@oc/customer-v2'

const useEcosystemLinksStyles = makeOcStyles(theme => ({
    actionsDiv: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1),
        flexGrow: 1,
        justifyContent: 'center'
    }
}))

function _EcosystemLinks() {
    const {classes} = useEcosystemLinksStyles()
    const state = useOcAppBarState()

    if (!state.s2aAccount) {
        return null
    }

    const isFlashAccount = state.s2aAccount.ecosystem === Ecosystem.Flash

    const availableActions = ocAppBarActions
        .filter(i => i.renderContext === OcAppBarActionContext.s2aLinks)
        .filter(action => !isFlashAccount || action.id === 's2a')

    return (
        <div data-cy="oc-app-bar-actions-div" className={classes.actionsDiv}>
            {availableActions.map(action => (
                <Tooltip title={action.text(state)} key={`oc-app-bar-default-action-${action.id}`}>
                    <span>
                        <IconButton
                            disabled={action.disabled(state)}
                            onClick={() => action.onClick(state)}
                            size="large"
                        >
                            {action.ocIcon(state)}
                        </IconButton>
                    </span>
                </Tooltip>
            ))}
        </div>
    )
}
export const EcosystemLinks = observer(_EcosystemLinks)
